import { Container, } from '@mui/material';

const CustomContainer = ({children,}) => {
    return (
        <Container disableGutters style={{maxWidth: 1240,}}  sx={{ px: '15px', height: '100%', }}>
            { children }
        </Container>
    );
};

export default CustomContainer;